<template>
<BlogComponent />
</template>

<script>
import BlogComponent from '/src/components/BlogComponent.vue';

export default {
    name: 'BodyBody',
    components: {
        BlogComponent
    }
}
</script>
